import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, Redirect, Route } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import SuperadminSidebar from "../Layout/SuperadminSidebar";
import Navbar from "../Layout/Navbar";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
//import { Dialog } from "@mui/material";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { DialogContentText } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useHistory } from "react-router-dom";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { displayAlertifyError } from "../../util/functions";
import { Input, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff,Edit,Add,CreditCard } from "@material-ui/icons";
import { displayAlertifySuccess } from "../../util/functions";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      margin: 0,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
    input: {
      display: "none",
    },
  })
);

const styles = (theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function ChangePassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let userEmail = localStorage.getItem("user_email");
  let name = localStorage.getItem("name");
  let user_status = localStorage.getItem("status");
  let subscription = localStorage.getItem("subscription");
  let created_at = localStorage.getItem("created_at");
  let renewdate = localStorage.getItem("renewdate");
  let sub_id = localStorage.getItem("sub_id");
  const stripestatus = localStorage.getItem("stripestatus");
  const [stripeStatus, setStripeStatus] = useState('');
  const [host, setHost] = useState(APIModel.HOST);
  const [baseUrl, setBaseUrl] = useState(APIModel.URL);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [items, setItems] = useState([]);
  const [company, setCompany] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [cards, setCards] = useState([]);
  const [noResult, setNoResult] = useState(false);

  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const handleClickOpenPopup = () => setOpenPopup(true);
  const handleClosePopup = () => setOpenPopup(false);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [card, setCard] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [type, setType] = useState("");
  const [csv, setCsv] = useState("");
  function updateProfile() {
    let password = $("#password").val();
    setPassword(password);

    if (password === "" || password === undefined) {
      displayAlertifyError({ error: "Please enter new password" });
      return false;
    }

    if (password !== confirmPassword) {
      displayAlertifyError({ error: "Passwords do not match" });
      return false;
    }

    let params = { email: userEmail, password: password };

    return axios
      .post(host + "reset-password", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.status === true) {
          displayAlertifySuccess({ message: response.data.message });
          localStorage.clear("token");
          history.push("/");
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  function cancelSubscription() {
    let params = {
      sub_id: sub_id,
    };
    // alertify.confirm(
    //   "Confirmation",
    //   "Are you sure?.",

    return axios
      .post(host + "cancel-subscribe", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.status === true) {
          displayAlertifySuccess({ message: response.data.message });
          logout();
        } else {
          displayAlertifyError({ error: response.data.message });
        }
      })
      .catch((response) => {
        console.log(response);
      });

    // function () {}
    // );
  }

  useEffect(async () => {
    if(cards.length == 0){
    getCards();
    }
   
  },[cards]);

  const getCards = async () => {
  
    setLoading(true);
    await axios
      .get(host + "cards/", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
       
        setCards(response.data.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function deleteCards(id) {
    // Check if there's only one card left
    if (cards.length === 1) {
      alertify.error("You cannot delete the last remaining card.");
      return;
    }
  
    // Show confirmation dialog
    alertify.confirm("Are you sure you want to delete this card?", function (e) {
      if (e) {
        // User confirmed the deletion
        axios
          .post(
            host + "cardsdelete/" + id,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            alertify.success(response.data.message);
            getCards();
          })
          .catch(function (error) {
            displayAlertifyError({ error: error });
          });
      }
    });
  }


  function UpdateCardDetails() {
    let fname = $("#fname").val();
    setFname(fname);
    
    let lname = $("#lname").val();
    setLname(lname);
    let card = $("#card").val();
    setCard(card);
    let year = $("#year").val();
    setYear(year);
    let month = $("#month").val();
    setMonth(month);
    let csv = $("#csv").val();
    setCsv(csv);
   
    let params = {
      user_id: userid,
      fname: fname,
      lname: lname,
      card: card,
      year: year.replace(' ', ''),
      month: month,
      cvv: csv,
      
    };

    if (fname === "" || fname === undefined) {
      alertify.error("Please enter first name");
      return false;
    }
    if (lname === "" || lname === undefined) {
      alertify.error("Please enter last name");
      return false;
    }
    if (card === "" || card === undefined) {
      alertify.error("Please enter card no");
      return false;
    }
    if (year === "" || year === undefined) {
      alertify.error("Please enter expiry year");
      return false;
    }
    if (month === "" || month === undefined) {
      alertify.error("Please enter expiry month");
      return false;
    }



    if (csv === "" || csv === undefined) {
      alertify.error("Please enter csv number");
      return false;
    }

    return axios
      .post(host + "cardupdate", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.status === false) {
          alertify.error(response.data.message);
        } else {
          alertify.success(response.data.message);
          setOpenPopup(false);
          getCards();
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  

  useEffect(() => {

    setStripeStatus(stripestatus);
    const handleMessage = (event) => {
      if (event.origin === 'https://api.securelienrelease.com') {
        const response = event.data;
        setLoading(false);
        if (response.success) {
          // Access token received, perform further actions in your React component
          displayAlertifySuccess({ message: response.message });
          //SetStripeResponseMessage(response.message);
          let params = {
            accountid: response.AccountId,
            accesstoken: response.accessToken,
            action: 'added'
          };
          return axios
            .post(host + "save-user-details", params, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + token,
              },
            })
            .then((response) => {
              if (response.data.status === true) {
                //displayAlertifySuccess({ message: response.data.message });
                localStorage.setItem(
                  "stripestatus",
                  'connected'
                );
                setStripeStatus('connected');
                //logout();
              }
            })
            .catch((response) => {
              console.log(response);
            });

        } else {
          // Handle error or failure case
        }

      }
    };


    window.onbeforeunload = function () {
      // Child window is closing
      if (window.opener && !window.opener.closed) {

        window.opener.postMessage({ success: false }, baseUrl);
      }
    };


    window.addEventListener('message', handleMessage);
    //window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('message', handleMessage);
      // window.addEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  function logout() {
    localStorage.clear("token");
    history.push("/");
  }
  let stripeAuthWindow = null;
  const handleRemove = (e) => {
    if (window.confirm('Are you sure you want to disconnect from Stripe?')) {
      let params = {
        action: 'removed',

      };
      return axios
        .post(host + "save-user-details", params, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          if (response.data.status === true) {
            displayAlertifyError({ error: response.data.message });
            localStorage.setItem("stripestatus", '');
            setStripeStatus('');
            //logout();
          } else {
            displayAlertifyError({ error: response.data.message });
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }
  const handleChildWindowClose = () => {
    // Child window closed without completing authentication
    setLoading(false);

    // Remove the event listener
    window.removeEventListener('beforeunload', handleChildWindowClose);
  };
  const handleConnect = (e) => {
    e.preventDefault();
    setLoading(true);
    stripeAuthWindow = window.open(baseUrl + 'connect', '_blank', 'width=800,height=600');
    const pollChildWindow = setInterval(() => {
      if (stripeAuthWindow && stripeAuthWindow.closed) {
        clearInterval(pollChildWindow);
        handleChildWindowClose();
      }
    }, 500);

    window.addEventListener('beforeunload', handleChildWindowClose);
  };


  const handleCloseDialog = () => {
    setIsOpenDialog((prev) => !prev);
  };

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <Dialog
            open={isOpenDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <Box sx={{ width: "400px" }}>
              <DialogTitle
                id="alert-dialog-title"
                style={{ textAlign: "center" }}
              >
                Confirmation
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ textAlign: "center" }}
                >
                  Are you sure to cancel subscription?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-primary pull-right"
                  onClick={() => {
                    handleCloseDialog();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary pull-right"
                  onClick={() => {
                    cancelSubscription();
                  }}
                >
                  Confirm
                </button>
              </DialogActions>
            </Box>
          </Dialog>
          {/* {user_status === 'admin' ? (
            <SuperadminSidebar />
          ) : (
            <Sidebar />
          )}
          <Navbar /> */}
          <SideNav user_status={user_status} />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                {user_status === "admin" ? (
                  <div></div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <Link to="/all-taxes" className="btn btn-primary">
                        Taxes
                      </Link>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-12 col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="text-center">
                          <h3 style={{ fontWeight: "bold" }}>
                            Change Password
                          </h3>
                        </div>
                        <form id="create_client">
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <label className="">Name</label>
                                <input
                                  type="text"
                                  className="form-control pl-2"
                                  id="rname"
                                  value={name}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <label className="">Email</label>
                                <input
                                  type="text"
                                  className="form-control pl-2"
                                  id="remail"
                                  value={userEmail}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12">
                              {/* <h4>{name}</h4>
                              <h4>{userEmail}</h4> */}
                              {/* <div className="form-group">
                                <label className="mdc-floating-label--shake">
                                  New Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control input-box"
                                  id="password"
                                  name="password"
                                  required="required"
                                  autoFocus
                                  onChange={(e) => setPassword(e.target.value)}
                                />
                              </div> */}
                              <FormControl
                                sx={{ m: 1 }}
                                variant="standard"
                                style={{ width: "100%" }}
                                className="form-group"
                              >
                                <label
                                  className="bmd-label-floating"
                                  htmlFor="password"
                                >
                                  New Password
                                </label>
                                <Input
                                  style={{ marginTop: "-.2rem" }}
                                  id="password"
                                  name="password"
                                  onChange={(e) => setPassword(e.target.value)}
                                  type={showPassword ? "text" : "password"}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() =>
                                          setShowPassword((prev) => !prev)
                                        }
                                      >
                                        {showPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <FormControl
                                sx={{ m: 1 }}
                                variant="standard"
                                style={{ width: "100%" }}
                                className="form-group"
                              >
                                <label
                                  className="bmd-label-floating"
                                  htmlFor="password"
                                >
                                  Confirm Password
                                </label>
                                <Input
                                  style={{ marginTop: "-.2rem" }}
                                  id="password"
                                  name="password"
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                  type={
                                    showConfirmPassword ? "text" : "password"
                                  }
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() =>
                                          setShowConfirmPassword(
                                            (prev) => !prev
                                          )
                                        }
                                      >
                                        {showConfirmPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </div>
                          <button
                            type="button"

                            className="btn btn-primary pull-right mt-4"
                            onClick={() => {
                              updateProfile();
                            }}
                          >
                            Update
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                  {user_status === "admin" ? (
                    <div></div>
                  ) : (
                    <div className="col-12 col-md-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="text-center">
                            <h3 style={{ fontWeight: "bold" }}>
                              Subscription Details
                            </h3>
                          </div>

                          <b>{subscription}</b>
                          <h4
                            style={{ fontWeight: "bold", marginTop: ".8rem" }}
                          >
                            Subscription Date
                          </h4>
                          <b>{created_at}</b>
                          <h4
                            style={{ fontWeight: "bold", marginTop: ".8rem" }}
                          >
                            Subscription Renew Date
                          </h4>
                          <b>{renewdate}</b>
                          <p>
                            <h4
                              style={{ fontWeight: "bold", marginTop: ".8rem" }}
                            >
                              Connect with Stripe to get payments from clients
                            </h4>
                            <button className="btn btn-primary" onClick={stripeStatus === 'connected' ? handleRemove : handleConnect} disabled={loading}>
                              {loading ? 'connecting...' : stripeStatus === 'connected' ? 'Disconnect from Stripe' : 'Connect with Stripe'}
                            </button>



                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                    {user_status === "admin" ? (
                    <div></div>
                  ) : (
                    <div className="col-12 col-md-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="text-center">
                            <h3 style={{ fontWeight: "bold" }}>
                             Payments options
                            </h3>
                          
                          </div>
                          <div>
                              {!loading ? (
                                cards && cards.length > 0 ? (
                                  cards.map((card) => (
                                    <List
                                      component="nav"
                                      aria-label="secondary mailbox folders"
                                      key={card.id}
                                    > 
                                    <Card>
                                     <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="50px" enable-background="new 0 0 50 50" viewBox="0 0 50 50" id="credit-card">
                                     <path d="M48.5386,15.0176c0-2.7568-2.2432-5-5-5H6.4614c-2.7568,0-5,2.2432-5,5v19.9648c0,2.7569,2.2432,5,5,5h37.0772
		c2.7568,0,5-2.2431,5-5V15.0176z M46.5386,34.9824c0,1.6543-1.3457,3-3,3H6.4614c-1.6543,0-3-1.3457-3-3V15.0176
		c0-1.6543,1.3457-3,3-3h37.0772c1.6543,0,3,1.3457,3,3V34.9824z"></path><path d="M17.4488 14.3701c-.951 0-1.8502.2174-2.6599.5955-.8303-.385-1.7352-.5974-2.6556-.5974-3.4785 0-6.3076 2.8359-6.3076 6.3213 0 3.4785 2.8291 6.3076 6.3076 6.3076.9197 0 1.8225-.2114 2.6507-.5949C15.5949 26.7817 16.4958 27 17.4488 27c3.4814 0 6.3144-2.833 6.3144-6.3144C23.7632 17.2031 20.9302 14.3701 17.4488 14.3701zM7.8257 20.6895c0-2.3829 1.9326-4.3213 4.3076-4.3213.2271 0 .4489.0222.668.0559-1.0321 1.1247-1.668 2.6183-1.668 4.2615 0 1.6406.6345 3.1324 1.6643 4.2564-.2178.0333-.4385.0551-.6643.0551C9.7583 24.9971 7.8257 23.0645 7.8257 20.6895zM17.4488 25c-2.3799 0-4.3155-1.9355-4.3155-4.3144 0-2.3799 1.9356-4.3155 4.3155-4.3155 2.3789 0 4.3144 1.9356 4.3144 4.3155C21.7632 23.0645 19.8277 25 17.4488 25zM22.7632 31.6914H7.314c-.5527 0-1 .4473-1 1s.4473 1 1 1h15.4492c.5527 0 1-.4473 1-1S23.3159 31.6914 22.7632 31.6914zM41.147 26.7744h-9.833c-.5527 0-1 .4473-1 1 0 .5528.4473 1 1 1h9.833c.5527 0 1-.4472 1-1C42.147 27.2217 41.6997 26.7744 41.147 26.7744zM41.147 31.6914h-9.833c-.5527 0-1 .4473-1 1s.4473 1 1 1h9.833c.5527 0 1-.4473 1-1S41.6997 31.6914 41.147 31.6914z"></path></svg>
                                       <CardNumber>**** **** **** {card.card_number}</CardNumber>
                                <Edit
                              type="button"
                              onClick={() => {
                                handleClickOpenPopup();
                              }}
                             
                            />
                            </Card>
                                      <Divider />
                                    </List>
                                  ))
                                ) : noResult ? (
                                  <h4>No results found!</h4>
                                ) : (
                                  <h1></h1>
                                )
                              ) : (
                                <Add
                                type="button"
                                onClick={() => {
                                  handleClickOpenPopup();
                                }}
                               
                              />
                              )}
                            </div>
                        </div>
                      </div>
                      <Dialog
                      onClose={handleClosePopup}
                      aria-labelledby="customized-dialog-title"
                      open={openPopup}
                    >
                      <DialogTitle
                        id="customized-card-title"
                        onClose={handleClosePopup}
                      >
                        Add  Card
                      </DialogTitle>
                      <DialogContent dividers>
                        <div className="">
                          <form>
                        <div className="row">
                        <div className="col-6 mt-2">
                            <div className="row">
                              <div className="col-12">
                                <div className="form-group">
                                  <label htmlFor="">First Name</label>
                                  <input type="text"
                                    className="form-control"
                                    name="fname"
                                    id="fname"
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 mt-2">
                            <div className="row">
                              <div className="col-12">
                                <div className="form-group">
                                  <label htmlFor="">Last Name</label>
                                  <input type="text"
                                    className="form-control"
                                    name="lname"
                                    id="lname"
                                    value={lname}
                                    onChange={(e) => setLname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                              <div className="col-12 mt-2">
                                <div className="form-group">
                                  <label className="">
                                    Card No
                                  </label>
                                  
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="card"
                                    name="card"
                                    value={card}
                                    onChange={(e) => {
                                      const inputCard = e.target.value.replace(/\s/g, ''); // Remove existing spaces
                                      const formattedCard = inputCard.slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 '); // Add space after every 4 digits
                                      setCard(formattedCard);
                                    }}
                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                 
                                </div>
                              </div>
                              <div className="col-4 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    Expiry Month
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control input-box"
                                    id="month"
                                    name="month"
                                    value={month}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 2) {

                                        formattedInput = `${month}`;
                                      }

                                      setMonth(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-4 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    Expiry Year
                                  </label>
                                  <input
                                    type="text"
                                    pattern="[0-9]*"
                                    className="form-control input-box"
                                    id="year"
                                    name="year"
                                    value={year}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 4) {

                                        formattedInput = `${year}`;
                                      }

                                      setYear(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-4 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    CVV Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control input-box"
                                    id="csv"
                                    name="csv"
                                    value={csv}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 4) {

                                        formattedInput = `${csv}`;
                                      }

                                      setCsv(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-6 mt-2">
                              <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={() => {
                              UpdateCardDetails();
                            }}
                          >
                           Update card
                          </button>
                          </div>
                        </div>
                         </form>
                        </div>
                      </DialogContent>
                    </Dialog>
                    </div>
                  )}

                

                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default ChangePassword;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;

const Card = styled.div`
  display: flex;
  margin: 30px 0px;
  align-items: center;
    justify-content: space-between;
`;
const CardNumber = styled.span`
font-size:18px;
`;
